import Vue from 'vue';
import svgicon from 'vue-svgicon';
import '@/svg/js';

Vue.use(svgicon, {
    tagName: 'svgicon',
});